<template>
  <div class="NotificationsItemStudyFollowUp">
    <LLTimestamp class="NotificationsItemStudyFollowUp__timestamp" :timestamp="notification.createdAt">
      <template #default="data">
        {{ data.time }}
      </template>
    </LLTimestamp>
    <p class="NotificationsItemStudyFollowUp__body">{{ followUp.body }}</p>
  </div>
</template>

<script>
import { NotificationModel } from '@/models/notification'
import LLTimestamp from '@/components/common/LLTimestamp.vue'

export default {
  name: 'NotificationsItemStudyFollowUp',
  components: { LLTimestamp },
  props: {
    notification: { type: NotificationModel, required: true }
  },
  computed: {
    followUp() {
      return this.notification.payload.studyFollowUp
    }
  }
}
</script>

<style scoped lang="scss">
.NotificationsItemStudyFollowUp {
  &__timestamp {
    @apply text-xs;
  }
  &__body {
    @apply mt-2 text-body-03 whitespace-pre-wrap break-words;
  }
}
</style>
